import axios from "axios";

import { attachAuthRefresh } from "../authRefresh";
import { getSessionToken } from "../session";

const sharedGetCache = new Map();
const DEFAULT_CACHE_TTL_MS = 5 * 60 * 1000;

const apiClient = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

apiClient.interceptors.request.use((config) => {
  const token = getSessionToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

attachAuthRefresh(apiClient);

const stableCacheKey = (endpoint, params = {}) => {
  const sortedEntries = Object.entries(params).filter(([, value]) => value !== undefined).sort(([left], [right]) => left.localeCompare(right));
  return `${endpoint}::${JSON.stringify(sortedEntries)}`;
};

export const clearSharedGetCache = () => {
  sharedGetCache.clear();
};

export const fetchCachedResource = async (endpoint, params = {}, ttlMs = DEFAULT_CACHE_TTL_MS) => {
  const cacheKey = stableCacheKey(endpoint, params);
  const now = Date.now();
  const cached = sharedGetCache.get(cacheKey);
  if (cached && cached.expiresAt > now) {
    if (cached.data) {
      return cached.data;
    }
    if (cached.promise) {
      return cached.promise;
    }
  }

  const requestPromise = apiClient.get(endpoint, { params }).then((response) => {
    sharedGetCache.set(cacheKey, { data: response.data, expiresAt: Date.now() + ttlMs });
    return response.data;
  }).catch((error) => {
    sharedGetCache.delete(cacheKey);
    throw error;
  });

  sharedGetCache.set(cacheKey, { promise: requestPromise, expiresAt: now + ttlMs });
  return requestPromise;
};

export default apiClient;